export default __webpack_public_path__ + "static/media/archery-icon.f6f829e1.svg";